import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  duration_time : '00:00',
  current_time : '00:00',
  video_src : '',
  play : true,
  range : 0,
  duration : 0,
  change_time : 0
};

const video = createSlice({
  name : "video",
  initialState,
  reducers : {
    resetVideo : () => initialState,
    resetCurrentVideo(state, action) {
      state.duration_time = '00:00';
      state.current_time = '00:00';
      state.video_src = '';
      state.range = 0;
      state.duration = 0;
      state.change_time = 0;
    },
    setDurationTime(state, action) {
      let minute = Math.floor(action.payload / 60);
      minute = minute < 10 ? "0" + minute.toString() : minute;
      
      let second = parseInt(action.payload - minute * 60);
      second = second < 10 ? "0" + second.toString() : second;

      state.duration_time = minute + ":" + second;
    },
    setCurrentTime(state, action) {
      let minute = Math.floor(action.payload / 60);
      minute = minute < 10 ? "0" + minute.toString() : minute;
      
      let second = parseInt(action.payload - minute * 60);
      second = second < 10 ? "0" + second.toString() : second;

      state.current_time = minute + ":" + second;
    },
    setVideoSrc(state, action) {
      state.video_src = action.payload;
    },
    setPlay(state, action) {
      state.play = action.payload;
    },
    setRange(state, action) {
      state.range = action.payload;
    },
    setDuration(state, action) {
      state.duration = action.payload;
    },
    setChangeTime(state, action) {
      state.change_time = action.payload;
    }
  }
});

export const { resetVideo, resetCurrentVideo, setDurationTime, setCurrentTime, setVideoSrc, setPlay, setRange, setDuration, setChangeTime } = video.actions;
 
export default video;